export default __webpack_public_path__ + "static/media/icon_3.36c4012e.png";